/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var NProgress = require('nprogress');
var Scaffold = require('common/layout/Scaffold');

var COCSubmitEventFollowupTaskView = require('./COCSubmitEventFollowupTaskView');
var GetEvent = require('../../../event/services/GetEvent');
var GetAllEventLookups = require('../../../common/services/GetAllEventLookups');

module.exports = {
  event: 'build:co:event-completion-follow-up',

  channel: 'task',

  builder: function(task) {
    var defer = $.Deferred();
    var departmentName = 'co';
    var eventId = task.taskData.COC.eventId;

    $.when(GetEvent(eventId), GetAllEventLookups())
      .done(function(event, lookups) {
        NProgress.set(0.85);
        Scaffold.content.show(
          new COCSubmitEventFollowupTaskView({
            model: new Backbone.Model({
              task: task,
              taskId: task.taskId,
              departmentName: departmentName,
              eventId: eventId,
              event: event,
              targetAudiences: lookups.targetAudiences,
              programs: lookups.programs,
              eventTypes: lookups.eventTypes,
              eventFormats: lookups.eventFormats
            })
          })
        );
        NProgress.done();
      })
      .fail(function(err) {
        defer.reject(err);
      });
    return defer.promise();
  }
};
